import React, {PropTypes} from 'react';
import BowlEventListContainer from './BowlEventListContainer.jsx';
import VirtualEventListContainer from './VirtualEventListContainer.jsx';
import ErrorListContainer from 'shared/error/ErrorListContainer.jsx';
import DisplayIf from 'shared/DisplayIf.jsx';
import StandardField from 'shared/StandardField.jsx';

const Events = ({
  eventsAreLinked,
  canLinkEvents,
  bowlEventsQty,
  virtualEventsQty,
  ageVerificationDate,
  readOnly,
  onNewBowlEventClick,
  onNewVirtualEventClick,
  onLinkedEventsToggleClick,
  onAgeVerificationDateChange,
  canCreateEvent,
  canCreateVirtualEvent
}) => (
  <div className="flex center animated fadeIn">
    <div className="col-xs-12 col-lg-8">
      <ErrorListContainer />

      <br/>
      <StandardField
        name="ageVerificationDate"
        type="date"
        label="Tournament Wide Age as of Date"
        placeholder="Date on which the bowler needs to be the specified age"
        input={{value: ageVerificationDate}}
        meta={{error: null, touched: true}}
        onCustomChange={value => onAgeVerificationDateChange(value)}
        disabled={readOnly}
        tooltip="Used to determine the starting date in an age specific tournament.  Adding the date here applies the age to ALL events in the tournament"
        tooltipPosition="top"
      />
      <br/>
      <div className="flex space-between vertical-center">
        <h2>{`Bowled Events`} <small>{`(${bowlEventsQty})`}</small></h2>
        <DisplayIf condition={!readOnly && canLinkEvents}>
          <button
            type="button"
            className="btn btn-link flex right"
            disabled={!canCreateEvent}
            onClick={onLinkedEventsToggleClick}
          >{`${eventsAreLinked ? 'Unlink' : 'Link'} Doubles/Singles`}</button>
        </DisplayIf>
        <DisplayIf condition={!readOnly}>
          <div className="text-right">
            <button
              type="button"
              className="btn btn-primary btn-lg"
              disabled={!canCreateEvent}
              onClick={onNewBowlEventClick}
            >{'Create Bowled Event'}</button>
          </div>
        </DisplayIf>
      </div>
      <h5>
        {'Events bowled by a participant – examples are team, doubles and singles'}
      </h5>
      {
        bowlEventsQty
        ? <BowlEventListContainer />
        : <div className="alert alert-info">{`No information to display.`}</div>
      }

      <br/>
      <div className="flex space-between vertical-center">
        <h2>{`Virtual Events`} <small>{`(${virtualEventsQty})`}</small></h2>
        <DisplayIf condition={!readOnly}>
          <div className="text-right">
            {
              bowlEventsQty
              ? <button
                  type="button"
                  className="btn btn-primary btn-lg"
                  disabled={!canCreateVirtualEvent}
                  onClick={onNewVirtualEventClick}
                >{'Create Virtual Event'}</button>
              :
                <button
                  type="button"
                  className="btn btn-primary btn-lg disabled"
                >{'Create Virtual Event'}</button>
            }
          </div>
        </DisplayIf>
      </div>
      <h5>
        {'Virtual Events are not bowled, but are calculated using bowled scores. Examples: All events Scratch, 6 game combined, Senior All Events, etc.'}
      </h5>
      {
        virtualEventsQty
        ? <VirtualEventListContainer />
      : <div className="alert alert-info">{`No information to display.`}</div>
      }
    </div>
  </div>
);

Events.propTypes = {
  eventsAreLinked: PropTypes.bool,
  canLinkEvents: PropTypes.bool,
  bowlEventsQty: PropTypes.number,
  virtualEventsQty: PropTypes.number,
  ageVerificationDate: PropTypes.string,
  readOnly: PropTypes.bool,
  onNewBowlEventClick: PropTypes.func,
  onNewVirtualEventClick: PropTypes.func,
  onLinkedEventsToggleClick: PropTypes.func,
  onAgeVerificationDateChange: PropTypes.func,
  canCreateEvent: PropTypes.bool,
  canCreateVirtualEvent: PropTypes.bool
};

Events.defaultProps = {
  bowlEventsQty: 0,
  virtualEventsQty: 0
};

export default Events;



// WEBPACK FOOTER //
// ./src/features/tournament/events/Events.jsx